/*
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-12-11 18:18:56
 * @LastEditors  : wjw
 * @LastEditTime : 2020-02-06 15:47:07
 */
import http from "./index";

export default {
  /*获取新闻资讯左边列表*/
  getLeftList: function(params) {
    return http.post("/index/categorylist", {
      category_type: params
    });
  },
  /*获取新闻资讯右边列表*/
  getRightList: function(type, start_page) {
    return http.post("/index/getArticleList", {
      type,
      start_page
    });
  },
  /*获取网络课程右边列表*/
  getInternetRightList: function(start_page) {
    return http.post("/index/getInternetLesson", {
      start_page
    });
  },
  /*获取文章内容*/
  getArticleInfo: function(articletitle) {
    return http.post("/index/getArticleInfo", { article_id: articletitle });
  },
  /*获取轮播图片文章内容*/
  getBannerContent: function(articletitle) {
    return http.post("/index/getBannerContent", { article_id: articletitle });
  },
  /*获取某个的网络课程章节信息*/
  getChaptersSectionsInfo: function(lesson_id, start_page) {
    return http.post("/index/getChaptersSectionsInfo", {
      lesson_id,
      start_page
    });
  },
  /*获取在线服务里的表单下载*/
  getFormList: function(start_page) {
    return http.post("/index/getFormList", { start_page });
  },
  /*在线服务里的表单下载点击进入表单详情*/
  getUploadFileList: function(form_id) {
    return http.post("/index/getUploadFileList", { form_id });
  },
  /*谏言献策 提交表单*/
  addUserAdvice: function(data) {
    return http.post(
      "/index/addUserAdvice",
      { data },
      {
        // 单独配置
        withCredentials: true
      }
    );
  },
  /*文章详情里下载文章 word, article_type：文章类型 article :文章;banner:轮播文章*/
  downloadWord: function(id, type) {
    return http.get("/index/downloadWord", { id, type });
  },
  /*获取5G智慧校园文档下载链接, article_type：文章类型 article :文章;banner:轮播文章*/
  getSmartSchoolWord() {
    return http.post("/api/index/getSmartSchoolWord");
  },
  // 获取疫情防控宣传专栏的 tabList
  getEpidemicControl(id) {
    return http.post("/api/index/getEpidemicControl", { id });
  }
};



// WEBPACK FOOTER //
// ./src/api/commonApi.js